import ConfigTab from "./ConfigTab";

export default ConfigTab;